import { useEffect, useState } from 'react';

export const useFormValidation = ({
    formActions,
    profileModel,
    validations,
    isUpdated,
    handleInvalidFormError,
    userProfileFormModelProp,
}) => {
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        if (!trigger) return;

        if (userProfileFormModelProp?.valid) {
            isUpdated?.();
        } else {
            handleInvalidFormError();
        }

        setTrigger(false);
    }, [userProfileFormModelProp]);

    const validateForm = value => {
        validations && formActions.validate(profileModel, validations);
        value !== '' && formActions.validate(profileModel, { required: true });
    };

    return {
        validateForm,
        setTrigger,
    };
};
